<template>
    <transition name="modal">
        <div id="loading" v-if="loading && show" @click="hide" :style="{backgroundColor : color}">
            <img src="/img/loader.svg">
        </div>
        <div id="overlay" v-else-if="show" @click="hide" :style="{backgroundColor : color}"></div>
    </transition>
</template>


<script>
    export default {
        data() {
            return {
                show: false,
                closable: true,
                loading: false,
                loading_img: '/img/loader.svg',
                color: '000000cc'
            }
        },
        methods: {
            hide(event) {
                console.log(this);
                if(!this.closable) {
                    return;
                }
                this.show = false;
                document.body.style.overflow = 'auto';
            }
        }
    }
</script>

<style lang="scss" scoped>
    #overlay {
        background: #000000cc;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 11;
    }

    #loading {
        background: #000000cc;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 11;

        img {
            position: fixed;
            width: 200px;
            height: 100px;
            top: 50%;
            left: 50%;
            margin-top: -50px; /* Negative half of height. */
            margin-left: -100px; /* Negative half of width. */
        }
    }
</style>